<ng-template #templateRef>
  <div class="p-inputgroup">
    <input type="number"
           pInputText
           class="text-center w-4rem"
           [disabled]="hasSameLimits"
           [(ngModel)]="rangeFilterValue[0]"
           (change)="filter()" />
    <input type="number"
           pInputText
           class="text-center w-4rem"
           [disabled]="hasSameLimits"
           [(ngModel)]="rangeFilterValue[1]"
           (change)="filter()" />
    @if (isFilterApplied) {
      <button pButton
              type="button"
              icon="pi pi-times"
              (click)="cleanFilter()"></button>
    }
  </div>
</ng-template>